import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const VulnerabilitiesIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 2.91669L15.2083 5.00002V8.95835C15.2083 12.3959 13.0125 15.5417 10 16.875C6.98746 15.5417 4.79163 12.3959 4.79163 8.95835V5.00002L10 2.91669ZM10 6.66669V10.4167M10 13.3334H10.0083"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </BaseIcon>
  );
};

VulnerabilitiesIcon.displayName = 'VulnerabilitiesIcon';
